<template>
  <div class="products-block">
    <selected-products
      :selected-products="selectedProducts"
      :show-purchase-price="showPurchasePrice"
      :is-editable="productsAreEditable"
      :block-type="blockType"
      @toggle-edit-modal="toggleEditModal"
      @remove-from-selected="removeFromSelected"
    />

    <app-button
      :disabled="!productsAreEditable"
      data-qa="show-all-corrections-button"
      @click="toggleListModal(true)"
    >
      {{ i18n.t('/Correcties/ShowAllOptions') }}
    </app-button>
    <modal
      v-if="showListModal"
      :title="i18n.t(`/ProductBlocks/${blockType}/Title`)"
      track-category="service flow"
      @close="toggleListModal(false)"
    >
      <loader v-if="loading" />

      <template v-else>
        <add-correction />

        <h4 data-qa="btn-toggle-extra-corrections" @click="toggleCorrections()">
          {{ i18n.t('/Correcties/AddCorrectieModal/OtherCorrectionsTitle') }}
        </h4>
        <template v-if="showCorrections">
          <product-categories
            v-for="(category, index) in allCategories"
            :key="index"
            :products="filterProductsByCategory(category)"
            :selected-products="selectedProducts"
            :show-purchase-price="showPurchasePrice"
            :show-incl-price="showInclPrice"
            :show-excl-price="showExclPrice"
            @add-to-selected="addToSelected"
            @remove-from-selected="removeFromSelected"
          />
        </template>
      </template>
    </modal>

    <app-button
      v-if="canAddProducts"
      :data-qa="`add-${blockType}-correction-button`"
      @click="toggleEditModal(true)"
    >
      {{ i18n.t(`/ProductBlocks/${blockType}/AddButton`) }}
    </app-button>

    <modal
      v-if="showEditModal"
      :title="editProductTitle"
      track-category="service flow"
      @close="toggleEditModal(false)"
    >
      <edit-product
        :show-purchase-price="showPurchasePrice"
        :product="editProduct"
        :categories="productsCategories"
        @close-edit-modal="closeEditModal"
      />
    </modal>
  </div>
</template>

<script>
import ProductCategories from '@/components/generic/presentational/molecules/productCategories/ProductCategories.vue'
import AppButton from '@/components/generic/presentational/atoms/appButton/AppButton.vue'
import Modal from '@/components/generic/presentational/molecules/modal/Modal.vue'
import Loader from '@/components/generic/presentational/atoms/loader/Loader.vue'
import SelectedProducts from '@/components/generic/presentational/molecules/selectedProducts/SelectedProducts.vue'
import EditProduct from '@/components/generic/presentational/molecules/editProduct/EditProduct.vue'
import AddCorrection from '@/components/generic/presentational/molecules/addCorrection/AddCorrection.vue'
import constants from '@/utils/constants'
import { mapGetters } from 'vuex'

export default {
  components: {
    Loader,
    AppButton,
    Modal,
    SelectedProducts,
    EditProduct,
    ProductCategories,
    AddCorrection,
  },
  props: {
    products: {
      type: Array,
      default: () => [],
    },
    selectedProducts: {
      type: Array,
      default: () => [],
    },
    canAddProducts: {
      type: Boolean,
      default: true,
    },
    showPurchasePrice: {
      type: Boolean,
      default: false,
    },
    productsAreEditable: {
      type: Boolean,
      default: true,
    },
    blockType: {
      type: String,
      required: true,
    },
    productsCategories: {
      type: Array,
      default: () => [],
    },
  },
  emits: ['add-to-selected', 'remove-from-selected'],
  data() {
    return {
      editProduct: null,
      showListModal: false,
      showEditModal: false,
      allCategories: constants.PRODUCT_CATEGORIES,
      showCorrections: false,
      i18n: window.VUE_CLI_EXPORTS.plugins.i18n,
    }
  },
  computed: {
    ...mapGetters({
      showInclPrice: 'quote/isPriceShowIncl',
      showExclPrice: 'quote/isPriceShowExcl',
    }),
    editProductTitle() {
      if (this.editProduct) {
        return 'Optie wijzigen'
      }
      return 'Optie aanmaken'
    },
    loading() {
      return this.products.length === 0
    },
  },
  methods: {
    toggleListModal(open) {
      this.showListModal = open
    },
    toggleEditModal(open, product) {
      this.editProduct = product
      this.showEditModal = open
    },
    toggleCorrections(hide) {
      this.showCorrections = !this.showCorrections
    },
    addToSelected(selectedProduct) {
      this.$emit('add-to-selected', selectedProduct)
      this.toggleListModal(false)
      this.toggleEditModal(true, selectedProduct)
    },
    removeFromSelected(deselectedProduct) {
      this.$emit('remove-from-selected', deselectedProduct)
    },
    closeEditModal(product) {
      this.toggleEditModal(false)
    },
    filterProductsByCategory(key) {
      return this.products.filter((p) => p.Category === key)
    },
  },
}
</script>

<style lang="scss" scoped>
.products-block {
  margin-bottom: 2em;
}

.category {
  position: relative;
}

.title {
  position: sticky;
  top: -0.6em;
  z-index: 9;
  background: #fff;
  margin-bottom: 0.5em;
  border-bottom: 1px solid $gray-light;
  padding: 0.25em 0 0.5em;
  box-shadow: $shadow-focus-ring;
}
</style>
